module.exports = __webpack_public_path__ + "static/img/msg.60d2568.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/msg.png
// module id = t3rl
// module chunks = 110